<ion-header>
  <ion-toolbar color="primary" no-border-bottom>
    <ion-buttons slot="start">
      <ion-button (click)="toggleGrid()">
        <!-- <ion-icon slot="icon-only" name="grid-outline" *ngIf="!showGrid"></ion-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-3x3 text-muted" viewBox="0 0 16 16" *ngIf="!showGrid">
          <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5V5h4V1zM5 6H1v4h4zm1 4h4V6H6zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5zm1 0v4h4v-4zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11zm0-1h4V6h-4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11zm-1 0V1H6v4z"/>
        </svg>
        <!-- <ion-icon slot="icon-only" name="square-outline" *ngIf="showGrid"></ion-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-3x3" viewBox="0 0 16 16" *ngIf="showGrid">
          <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5V5h4V1zM5 6H1v4h4zm1 4h4V6H6zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5zm1 0v4h4v-4zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11zm0-1h4V6h-4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11zm-1 0V1H6v4z"/>
        </svg>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="photo">{{ 'APP.TYPE.' + photo.type | translate }}</ion-title>
    <ion-title *ngIf="!photo">{{ 'APP.TITLE.PhotoPreview' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content padding>
  <ion-grid>
    <ion-row>
      <ion-col class="text-center">
        <div class="d-flex justify-content-center align-items-center text-break text-center mt-5" *ngIf="spin">
          <ion-spinner name="circular" color="medium"></ion-spinner>
        </div>    
        <!-- <img [src]="imageUrl" alt="medical photo" width="100%" *ngIf="!spin" /> -->
        <div class="ratio- text-center img-overlay-wrap" style="--bs-aspect-ratio: 125%;background-color: #fafafa;min-height: 500px;max-width: 720px;" *ngIf="!spin">
          <img class="img-fluid" [src]="imageUrl" />
          <img class="overlay-img" [src]="'./assets/images/' + (showGrid ? 'grid' : 'guide') + '_720_1280.png'" />
          <!-- <svg [attr.viewBox]="_viewBox" *ngIf="!photo.ai_result">
            <line
              [attr.x1]="_widthBox / 2"
              [attr.y1]="0"
              [attr.x2]="_widthBox / 2"
              [attr.y2]="_height"
              [attr.stroke-width]="1"
              [attr.stroke]="_axisColor">
            </line>
          </svg> -->
          <svg [attr.viewBox]="_viewBox" *ngIf="photo.ai_result">
            <!-- <line
              [attr.x1]="_widthBox / 2"
              [attr.y1]="0"
              [attr.x2]="_widthBox / 2"
              [attr.y2]="_height"
              [attr.stroke-width]="1"
              [attr.stroke]="_axisColor">
            </line> -->
            <!-- line hip -->
            <line *ngIf="svgDrawOptions.hip[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.hip.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.hip.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.hip.right[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.hip.right[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColor">
            </line>
            <!-- line shoulder -->
            <line *ngIf="svgDrawOptions.shoulder[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.shoulder.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.shoulder.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.shoulder.right[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.shoulder.right[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColor">
            </line>
            <!-- left -->
            <line *ngIf="svgDrawOptions.elbow[photo.type] && svgDrawOptions.wrist[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.elbow.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.elbow.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.wrist.left[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.wrist.left[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorLeft">
            </line>
            <line *ngIf="svgDrawOptions.elbow[photo.type] && svgDrawOptions.shoulder[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.elbow.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.elbow.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.shoulder.left[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.shoulder.left[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorLeft">
            </line>
            <line *ngIf="svgDrawOptions.hip[photo.type] && svgDrawOptions.shoulder[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.hip.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.hip.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.shoulder.left[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.shoulder.left[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorLeft">
            </line>
            <line *ngIf="svgDrawOptions.shoulder[photo.type] && svgDrawOptions.nose[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.shoulder.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.shoulder.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.nose[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.nose[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorLeft">
            </line>
            <line *ngIf="svgDrawOptions.eye[photo.type] && svgDrawOptions.nose[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.eye.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.eye.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.nose[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.nose[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorLeft">
            </line>
            <line *ngIf="svgDrawOptions.eye[photo.type] && svgDrawOptions.ear[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.eye.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.eye.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.ear.left[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.ear.left[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorLeft">
            </line>
            <line *ngIf="svgDrawOptions.hip[photo.type] && svgDrawOptions.knee[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.hip.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.hip.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.knee.left[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.knee.left[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorLeft">
            </line>
            <line *ngIf="svgDrawOptions.ankle[photo.type] && svgDrawOptions.knee[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.ankle.left[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.ankle.left[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.knee.left[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.knee.left[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorLeft">
            </line>
            <!-- right -->
            <line *ngIf="svgDrawOptions.elbow[photo.type] && svgDrawOptions.wrist[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.elbow.right[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.elbow.right[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.wrist.right[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.wrist.right[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorRight">
            </line>
            <line *ngIf="svgDrawOptions.elbow[photo.type] && svgDrawOptions.shoulder[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.elbow.right[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.elbow.right[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.shoulder.right[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.shoulder.right[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorRight">
            </line>
            <line *ngIf="svgDrawOptions.hip[photo.type] && svgDrawOptions.shoulder[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.hip.right[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.hip.right[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.shoulder.right[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.shoulder.right[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorRight">
            </line>
            <line *ngIf="svgDrawOptions.shoulder[photo.type] && svgDrawOptions.nose[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.shoulder.right[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.shoulder.right[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.nose[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.nose[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorRight">
            </line>
            <line *ngIf="svgDrawOptions.eye[photo.type] && svgDrawOptions.nose[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.eye.right[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.eye.right[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.nose[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.nose[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorRight">
            </line>
            <line *ngIf="svgDrawOptions.eye[photo.type] && svgDrawOptions.ear[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.eye.right[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.eye.right[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.ear.right[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.ear.right[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorRight">
            </line>
            <line *ngIf="svgDrawOptions.hip[photo.type] && svgDrawOptions.knee[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.hip.right[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.hip.right[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.knee.right[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.knee.right[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorRight">
            </line>
            <line *ngIf="svgDrawOptions.hip[photo.type] && svgDrawOptions.knee[photo.type]"
              [attr.x1]="photo.ai_result.keypoint_map.ankle.right[0] * _width"
              [attr.y1]="photo.ai_result.keypoint_map.ankle.right[1] * _height"
              [attr.x2]="photo.ai_result.keypoint_map.knee.right[0] * _width"
              [attr.y2]="photo.ai_result.keypoint_map.knee.right[1] * _height"
              [attr.stroke-width]="3"
              [attr.stroke]="_lineColorRight">
            </line>
  
            <ng-container *ngIf="photo.ai_result.keypoint_map.ear && svgDrawOptions.ear[photo.type]">
              <!-- ear -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.ear.left[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.ear.left[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
              <circle [attr.cx]="photo.ai_result.keypoint_map.ear.right[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.ear.right[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
            <ng-container *ngIf="photo.ai_result.keypoint_map.eye && svgDrawOptions.eye[photo.type]">
              <!-- eye -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.eye.left[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.eye.left[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
              <circle [attr.cx]="photo.ai_result.keypoint_map.eye.right[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.eye.right[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
            <ng-container *ngIf="photo.ai_result.keypoint_map.nose && svgDrawOptions.nose[photo.type]">
              <!-- nose -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.nose[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.nose[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
            <ng-container *ngIf="photo.ai_result.keypoint_map.shoulder && svgDrawOptions.shoulder[photo.type]">
              <!-- shoulder -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.shoulder.left[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.shoulder.left[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
              <circle [attr.cx]="photo.ai_result.keypoint_map.shoulder.right[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.shoulder.right[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
            <ng-container *ngIf="photo.ai_result.keypoint_map.elbow && svgDrawOptions.elbow[photo.type]">
              <!-- elbow -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.elbow.left[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.elbow.left[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
              <circle [attr.cx]="photo.ai_result.keypoint_map.elbow.right[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.elbow.right[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
            <ng-container *ngIf="photo.ai_result.keypoint_map.hip && svgDrawOptions.hip[photo.type]">
            <!-- hip -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.hip.left[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.hip.left[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
              <circle [attr.cx]="photo.ai_result.keypoint_map.hip.right[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.hip.right[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
            <ng-container *ngIf="photo.ai_result.keypoint_map.knee && svgDrawOptions.knee[photo.type]">
              <!-- knee -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.knee.left[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.knee.left[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
              <circle [attr.cx]="photo.ai_result.keypoint_map.knee.right[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.knee.right[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
            <ng-container *ngIf="photo.ai_result.keypoint_map.wrist && svgDrawOptions.wrist[photo.type]">
              <!-- wrist -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.wrist.left[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.wrist.left[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
              <circle [attr.cx]="photo.ai_result.keypoint_map.wrist.right[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.wrist.right[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
            <ng-container *ngIf="photo.ai_result.keypoint_map.ankle && svgDrawOptions.ankle[photo.type]">
              <!-- ankle -->
              <circle [attr.cx]="photo.ai_result.keypoint_map.ankle.left[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.ankle.left[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
              <circle [attr.cx]="photo.ai_result.keypoint_map.ankle.right[0] * _width" [attr.cy]="photo.ai_result.keypoint_map.ankle.right[1] * _height" [attr.r]="_r" [attr.fill]="_fillColor" />
            </ng-container>
          </svg>
        </div>  
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
